<!--
    file type .....: HTML file: event-messages.component.html
    Created By ....: ianday
    Date ..........: 2/28/24 
-->
<div class="integration-container">
    <div class="heading-text-style">Application Submission Integration</div>

    <div class="dwform" style="margin-left:20px">

        <div class="dwform-row-gap"></div>



        <label class="label-field label-field-override">Enable/Disable:</label>
        <label class="form-required"> </label>

        <dw-dropdown [disabled]="!visibleModify"
        [selectedItem]="selectedValue"
        [dataSource]="enabledList"
        [controlWidth]="'180px'"
        (itemSelected)="selectedValue = $event;updateIntegrationStatus($event)"></dw-dropdown>

        <div class="dwform-row-gap"></div>
        <div class="dwform-row-gap"></div>

        <label class="label-field label-field-override">Service Status:</label>
        <label class="form-required"> </label>
        <label [ngStyle]="settingsRecord.value === 'true' ? {'color':'green'} : {'color':'red'}">
            {{currentRunState}}
        </label>


        <div class="dwform-row-gap"></div>
        <div class="dwform-row-gap"></div>



        <label class="label-field label-field-override">Imported Cases Today:</label>
        <label class="form-required"> </label>
        <label>0</label>

        <div class="dwform-row-gap"></div>
        <div class="view-log" [hidden]="true">
            <button mat-button class="command-button">
                <mat-icon>search</mat-icon>View Log</button>
        </div>
    </div>
</div>
